import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13fed696"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "one_c" }
const _hoisted_2 = { class: "form-grid" }
const _hoisted_3 = { class: "flex justify-end mt-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_one_c_deliveries_list_item = _resolveComponent("one-c-deliveries-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.loadOneC(1)), ["prevent"])),
      class: "one_c__form"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Курьер",
          loading: _ctx.data_state.couriers.is_loading,
          failed: _ctx.data_state.couriers.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.couriers.list,
          value: _ctx.state.courierIds,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courierIds) = $event)),
          "search-without-refresh": "",
          label: "fullName",
          multiselect: "",
          onRefresh: _ctx.loadCouriers,
          onSearch: _ctx.searchCouriers,
          onOptionBySearch: _ctx.unshiftFindedCourier,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Компания",
          loading: _ctx.data_state.companies.is_loading,
          failed: _ctx.data_state.companies.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.companies.list,
          value: _ctx.state.companyIds,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.companyIds) = $event)),
          multiselect: "",
          onRefresh: _ctx.loadCompanies,
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Сектор диспетчера",
          loading: _ctx.data_state.dispatcher_sectors.is_loading,
          failed: _ctx.data_state.dispatcher_sectors.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.dispatcher_sectors.list,
          value: _ctx.state.dispatcherSectorIds,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dispatcherSectorIds) = $event)),
          multiselect: "",
          onRefresh: _ctx.loadDispatcherSectors,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadOneC(1))),
          "search-without-refresh": ""
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер накладной",
          value: _ctx.state.invoiceNumber,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Адрес получателя",
          value: _ctx.state.address,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.address) = $event)),
          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата от",
          value: _ctx.state.createdAtFrom,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.createdAtFrom) = $event)),
          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата до",
          value: _ctx.state.createdAtTo,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.createdAtTo) = $event)),
          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadOneC(1)))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second text small",
          loading: _ctx.state.is_loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small ml-2",
          loading: _ctx.state.is_loading,
          onClick: _ctx.resend
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Прокинуть ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small ml-2",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.data_state.one_c.is_failed && !_ctx.data_state.one_c.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.one_c.is_loading,
            text: "При получении истории заказов произошла ошибка",
            "error-message": _ctx.data_state.one_c.failure.error_state.message,
            "error-url": _ctx.data_state.one_c.failure.error_state.url,
            "error-status": _ctx.data_state.one_c.failure.error_state.status,
            onRefresh: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadOneC(_ctx.data_state.one_c.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.data_state.one_c.is_loading,
            items: _ctx.data_state.one_c.list,
            pagination: "",
            "pagination-current-page": _ctx.data_state.one_c.pagination.current_page,
            "pagination-total-pages": _ctx.data_state.one_c.pagination.total_pages,
            onChangePage: _ctx.loadOneC
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_one_c_deliveries_list_item, { item: item }, null, 8, ["item"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}